import React, {useEffect} from 'react'
import { formatNumber } from '../../../../utils/tools'
import { InputContainer } from '../../DepositElements'
const CuentasOnline = ({form, setForm, handleChange, cuenta}) => {
  useEffect(()=>{
    setForm({...form, numeroCuenta:'', nombreApellido:'',monto2:''})
  },[])
  return (
    <>
      <InputContainer>
        <label>CUENTA {cuenta}:</label>
        <input type='text' name='numeroCuenta' placeholder='CUENTA' value={form.numeroCuenta} onChange={handleChange} required/>
      </InputContainer>
      <InputContainer>
        <label>NOMBRES Y APELLIDOS:</label>
        <input type='text' name='nombreApellido' placeholder='NOMBRES Y APELLIDOS' value={form.nombreApellido} onChange={handleChange} required/>
      </InputContainer>
      <InputContainer>
        <label>MONTO:</label>
        <input type='text' name='monto2' value={form.monto2} placeholder='0,00' onChange={(e)=>handleChange(formatNumber(e))} required/>
      </InputContainer>
    </>
  )
}

export default CuentasOnline